<template>
    <v-carousel :show-arrows="false" class="mx-a" cycle height="280" hide-delimiter-background show-arrows-on-hover>
        <v-carousel-item v-for="(slide, i) in slides" :key="i">
            <v-sheet color="none" height="100%">
                <v-row align="center" class="fill-height" justify="center">
                    <div class="display-3 slide-text">{{ slide }}</div>
                </v-row>
            </v-sheet>
        </v-carousel-item>
    </v-carousel>
</template>

<script>
export default {
    data() {
        return {
            colors: ['indigo', 'warning', 'pink darken-2', 'red lighten-1', 'deep-purple accent-4'],
            slides: ['Slide 1', 'Slide 2'],
        };
    },
};
</script>

<style></style>
